<template>
    <div class="parts-rules">
        <Navbar :statusHeight="statusHeight" :language="language" :title="$t('说明')" :isNavtiveBack="false"></Navbar>
        <div class="content">
            <div class="descript">
                <h6 :class="[language]">{{ $t('兑换说明') }}</h6>
                <p>{{ $t('1、虚拟商品一经兑换概不退换') }}</p>
                <p>{{ $t('2、已开始使用的商品，无法取消使用') }}</p>
                <p>{{ $t('3、使用到期后，效果或权益自动消失') }}</p>
                <p>{{ $t('4、兑换商品全部放入背包') }}</p>
                <p>{{ $t('5、商品兑换的解释说明权归平台所有') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import { appFunc_changeBar } from '@/utils/bridge'

export default {
    components: {
        Navbar
    },
    data: () => {
        return {
            language: 'ug',
            statusHeight: 0
        }
    },
    created() {
        this.language = this.$route.query.language;
        this.statusHeight = +this.$route.query.statusHeight;
        appFunc_changeBar({statusBarModel: true, navBarBackground: '#fff'})
    },
}
</script>

<style lang="scss" scoped>
.content {
    padding: 16px 25px;
    font-size: 14px;
    line-height: 24px;

    h6 {
        font-weight: 500;
        color: #333333;
        padding-bottom: 5px;
    }

    .descript {
        font-weight: 400;
        color: #5C5C5C;
        padding-bottom: 5px;
    }
}
</style>